import { PromoInfoFormFieldNames } from 'constants/tpo';
import { FieldTypes, FormField, OperatorTypes } from 'types/tpo/promoInfo';
import { PromotionTypes } from 'utils/Enums';

export const formFields: FormField[] = [
    {
        name: 'name',
        type: FieldTypes.Text,
        label: 'Promo Name',
        tooltip: 'Enter the name of the promo tactic.',
        isRequired: true,
        maxCharLimit: 40,
    },
    {
        name: 'tpmPromoId',
        type: FieldTypes.Text,
        label: 'TPM Promo ID',
        isRequired: false,
        isDisabled: true,
    },
    {
        name: 'status',
        type: FieldTypes.Select,
        label: 'Status',
        isRequired: false,
    },
    {
        name: 'customPromo',
        type: FieldTypes.Text,
        label: 'Custom Promo',
        isRequired: false,
        isDisabled: true,
    },
    {
        name: PromoInfoFormFieldNames.FundingRequest,
        type: FieldTypes.Select,
        label: 'Funding Req',
        isRequired: false,
        maxCharLimit: 50,
    },
    {
        name: PromoInfoFormFieldNames.PromoType,
        type: FieldTypes.Select,
        label: 'Promo Type',
        isRequired: true,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: '0',
                            operator: OperatorTypes.isNotEqual,
                            field: 'promoId',
                            fieldType: FieldTypes.Text,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isDisabled',
        },
    },
    {
        name: PromoInfoFormFieldNames.TacticType,
        type: FieldTypes.Select,
        label: 'Tactic Type',
        isRequired: true,
    },
    {
        name: PromoInfoFormFieldNames.FeatureQuality,
        type: FieldTypes.Select,
        label: 'Feature Quality',
        isRequired: false,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: [3, 4],
                            operator: OperatorTypes.NotIn,
                            field: 'tacticType',
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: 'tacticType',
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isDisabled',
        },
    },
    {
        name: PromoInfoFormFieldNames.DisplayQuality,
        type: FieldTypes.Select,
        label: 'Display Quality',
        isRequired: false,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: [2, 4],
                            operator: OperatorTypes.NotIn,
                            field: 'tacticType',
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: 'tacticType',
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isDisabled',
        },
    },
    {
        name: PromoInfoFormFieldNames.ParNumber,
        type: FieldTypes.Text,
        label: 'Par #',
        isRequired: false,
        maxCharLimit: 50,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: [PromotionTypes.SM_ISM, PromotionTypes.SM_MDF],
                            operator: OperatorTypes.NotIn,
                            field: PromoInfoFormFieldNames.PromoType,
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: PromoInfoFormFieldNames.PromoType,
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isDisabled',
        },
    },
    {
        name: 'promoStartDate',
        type: FieldTypes.Date,
        label: 'Promo Start',
        isRequired: true,
        copyValueTo: PromoInfoFormFieldNames.CRAStartDate,
    },
    {
        name: 'promoEndDate',
        type: FieldTypes.Date,
        label: 'Promo End',
        isRequired: true,
        copyValueTo: PromoInfoFormFieldNames.CRAEndDate,
    },
    {
        name: 'craStartDate',
        type: FieldTypes.Date,
        label: 'CRA Start',
        isRequired: true,
    },
    {
        name: 'craEndDate',
        type: FieldTypes.Date,
        label: 'CRA End',
        isRequired: true,
    },
    {
        name: PromoInfoFormFieldNames.IsmCampaignId,
        type: FieldTypes.Text,
        label: 'Campaign ID',
        isRequired: false,
        maxCharLimit: 50,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: PromotionTypes.SM_ISM,
                            operator: OperatorTypes.isNotEqual,
                            field: PromoInfoFormFieldNames.PromoType,
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: PromoInfoFormFieldNames.PromoType,
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isDisabled',
        },
    },
    {
        name: PromoInfoFormFieldNames.ContractNumber,
        type: FieldTypes.Text,
        label: 'Contract #',
        isRequired: false,
        maxCharLimit: 50,
    },
    {
        name: 'offerType',
        type: FieldTypes.Select,
        label: 'Offer Method',
        isRequired: true,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: [PromotionTypes.Merchandising, PromotionTypes.SM_MDF],
                            operator: OperatorTypes.NotIn,
                            field: PromoInfoFormFieldNames.PromoType,
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: PromoInfoFormFieldNames.PromoType,
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isDisabled',
        },
    },
    {
        name: PromoInfoFormFieldNames.ManualOffer,
        type: FieldTypes.Select,
        label: 'Offer',
        isRequired: true,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: 'manual',
                            operator: OperatorTypes.isNotEqual,
                            field: 'offerType',
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: 'offerType',
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isHidden',
        },
    },
    {
        name: 'offer',
        type: FieldTypes.OfferLibrary,
        label: 'Offer',
        isRequired: true,
        placeholder: 'Select Offer',
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: 'manual',
                            operator: OperatorTypes.isEqual,
                            field: 'offerType',
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: 'offerType',
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isHidden',
        },
    },
    {
        name: 'discount',
        type: FieldTypes.PriceOff,
        label: 'Price off/Disc',
        isRequired: true,
        isHidden: false,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: 'price_off',
                            operator: OperatorTypes.isNotEqual,
                            field: PromoInfoFormFieldNames.ManualOffer,
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: PromoInfoFormFieldNames.ManualOffer,
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isHidden',
        },
    },
    {
        name: 'buyGet',
        type: FieldTypes.Range,
        label: 'Buy & Get',
        isRequired: true,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: 'combination_offer',
                            operator: OperatorTypes.isNotEqual,
                            field: PromoInfoFormFieldNames.ManualOffer,
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: PromoInfoFormFieldNames.ManualOffer,
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isHidden',
        },
    },
    {
        name: 'buyFor',
        type: FieldTypes.Range,
        label: 'Buy For',
        isRequired: true,
        disableUnits: true,
        conditions: {
            rules: [
                {
                    conditions: [
                        {
                            value: 'buy_for',
                            operator: OperatorTypes.isNotEqual,
                            field: PromoInfoFormFieldNames.ManualOffer,
                            fieldType: FieldTypes.Select,
                        },
                        {
                            value: '',
                            operator: OperatorTypes.isEmpty,
                            field: PromoInfoFormFieldNames.ManualOffer,
                            fieldType: FieldTypes.Select,
                        },
                    ],
                    conjunction: 'any',
                },
            ],
            action: 'isHidden',
        },
    },
];
